
import _find from 'lodash/find.js';
import _findIndex from 'lodash/findIndex.js';
import { extractModelOptionsData, extractBaseModelSpecsData, getInitColor, sortWheelsArray } from './utilities.js';
import { getFormattedPrice } from '_ui-core-js/utilities/getFormattedPrice.js';
import { upperCaseWithBrandStrings } from '_ui-core-js/utilities/upperCaseWithBrandStrings.js';

const createFitlersData = data => { 

  const filterState = {
    all: {
      name: data.filters.all,
      indexes: [...Array(data.models.length).keys()],
      count: data.models.length
    }
  };
  data.models.forEach((model, index) => {
    if (model.type !== 'campaign') {
      model.classifications.forEach(classificationId => {
        if (filterState[classificationId]) {
          filterState[classificationId].count += 1;
          filterState[classificationId].indexes.push(index);
        } 
        else {
         // if (data.filters[classificationId]) {
            filterState[classificationId] = {
              count: 1,
              indexes: [index],
              name: upperCaseWithBrandStrings(_find(data.classifications, { id: classificationId }).name)
            };
          }
       // }
      });
    }
  });
  return filterState;
};

export function createRangeState(data) {
  
  const state = {

    title: data.title,
    configuratorActive: false,
    selectedModel: {
      index: 0,
      carouselIndex: 0,
      filterClassificationId: 'all'
    },
    filters: createFitlersData(data),
    models: data.models.map((model, index) => {

      let initColor;
      let wheels;
      let price;
      let car;
      let seats;
      let fuel;
      let wheelsSorted;

      if (model.type !== 'campaign') {
        car = model.cars[0];
        initColor = getInitColor(model, car);
        wheelsSorted = sortWheelsArray(extractModelOptionsData(model, 0, 'wheels')); // order with 'option' type first and and 'accessory' type last
        wheels = car.wheels ? wheelsSorted[0]: {};
        price = car.price?.list ? getFormattedPrice(car.price.list) : '-';
        const seatsNumber = extractBaseModelSpecsData(model, 'loadcap', 'NumberOfSeats');
        seats = seatsNumber ? data.detailsView.numberOfSeatsValue.replace('{{ VALUE }}', seatsNumber) : '-';
        const fuelComsumptionFrom = extractBaseModelSpecsData(model, 'fuel consumption', 'FUELCOMBINEDWLTPMPGMIN');
        const fuelComsumptionTo = extractBaseModelSpecsData(model, 'fuel consumption', 'FUELCOMBINEDWLTPMPG');
        fuel = fuelComsumptionFrom && fuelComsumptionTo ? `${fuelComsumptionFrom} - ${fuelComsumptionTo} mpg` : '-';
      }
      
      return {
        displayCard: model.type !== 'campaign' ? 
        ({
          retailModel: true,
          modelName: model.model.replace(/\s/g, ""),
          description: model.tagline,
          priceFromText: model.pricetag,
          priceValue: price,
          ccisImgConfig: {
            angle: 9,
            width: 1200,
            quality: 80,
            color: initColor.code,
            upholstery: _find(model.upholsteries, {id: car.uholsteries[0]}).code, // typo introduced by tme datablock
            wheel: wheels.short,
            wheelType: wheels.type,
            token: model.token,
            vehicle: car.id,
            type: 'day-exterior',
            countryCode: data.country,
            baseUrl: model.imageProps?.baseUrl ? model.imageProps.baseUrl : 'https://kong-proxy-aws.toyota-europe.com'
          },
          imgAltText: 'vehicle side profile',
          buttonOneText: model.primaryCta || 'TAKE A CLOSER LOOK',
          buttonTwoText: model.secondaryCta ? model.secondaryCta.replace('{{ MODEL }}', model.model) : 'EXPLORE THE MODEL',
          nextSteps: {
            text: data.nextSteps.availableAs.replace('{{ ENGINE }}', model.availableAs ? model.availableAs : _find(model.engines, {id: model.cars[0].engine}).fuel),
            buttonOne: {
              text: data.nextSteps?.reserveCtaLabel ? data.nextSteps.reserveCtaLabel.replace('{{ MODEL }}', model.model) : undefined,
              url: data.nextSteps?.reserveCtaUrl ? data.nextSteps.reserveCtaUrl : undefined,
              type: 'secondary',
              trackingId: 'reserve'
            },
            buttonTwo: {
              text: data.nextSteps?.featuresCtaLabel ? data.nextSteps.featuresCtaLabel : undefined,
              url: data.nextSteps?.featuresCtaUrl ? data.nextSteps.featuresCtaUrl : undefined,
              type: 'primary',
              trackingId: 'features'
            }
          }
        }) : ({
          retailModel: false,
          modelName: model.model.replace(/\s/g, ""),
          description: model.tagline,
          backgroundImg: model.backgroundImage,
          buttonOneText: model.primaryCta || 'TAKE A CLOSER LOOK',
          buttonTwoText: model.secondaryCta ? model.secondaryCta.replace('{{ MODEL }}', model.model) : 'EXPLORE THE MODEL',
          video: {
            src: model.video,
            poster: model.poster || '',
            label: model.label || ''
          },
          nextSteps: {
            text: '',
            buttonOne: {
              text: data.nextSteps.keepInformedCtaLabel,
              url: data.nextSteps.keepInformedCtaUrl,
              type: 'primary',
              trackingId: 'keepInformed'
            },
            buttonTwo: {
              text: '',
              url: '',
              type: 'secondary'
            }
          }
        }), 
        ...(model.type !== 'campaign' && {
          configurator: {
            activeSelections: {
              colors: initColor.index,
              wheels: 0,
              upholsteries: 0,
              accessories: []
            },
            options: {
              colors: extractModelOptionsData(model, 0, 'colours'),
              upholsteries: extractModelOptionsData(model, 0, 'upholsteries'),
              wheels: wheelsSorted,
              accessories: extractModelOptionsData(model, 0, 'accessories')
            },
            details: {
              price: price,
              size: _find(data.classifications, { id: model.classifications[0] }).name,
              seats: seats,
              fuel: fuel
            },
            labels: {
              colors: data.customiseView.exteriorColor || 'Exterior Colour',
              wheels: data.customiseView.wheels || 'Wheels',
              upholsteries: data.customiseView.interiorColors || 'Interior Colour',
              accessories: data.customiseView.accessories || 'Accessories',
              details: data.customiseView.viewCarDetails || 'View Car Details',
              price: data.detailsView.priceFrom || 'Price From',
              size: data.detailsView.carSize || 'Car Size',
              seats: data.detailsView.numberOfSeats || 'Number Of Seats',
              fuel: data.detailsView.fuelEconomy || 'Fuel Economy',
              customise: data.detailsView.customise || 'Customise Car'
            }
          }
        })
      }
    })
  };

  return state;
};
